/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

/*
 * A tiny, dependency-free registry of each model form's "flush the pending debounced autosave NOW"
 * function, keyed by form name (UI design §3.4 / data & API design §4.1). Accept/reject are discrete
 * commits (unlike typing), and flushing immediately makes the model's UPDATE_MODEL_REQUEST fire
 * synchronously -- which sets the model "updating" (the poller skips) and invalidates in-flight poll
 * fetches -- so a stale poll response cannot revert the just-persisted marking before the save
 * round-trips.
 *
 * Deliberately its own module with NO other imports: middlewares/modelForm/index.js (which populates
 * this) pulls in the full per-model-type middleware construction chain (buildValidationContext ->
 * selectors/entities/components.js), so importing that module from the actions layer (aiReview.js)
 * would transitively drag that whole chain into any module that just wants to flush a pending save --
 * which broke module load entirely in a narrower import context (a load-order-sensitive selector
 * definition). aiReview.js imports ONLY this file.
 */
const flushFunctionsByForm = {};

export const registerFormSaveFlush = (formName, flushFn) => {
  flushFunctionsByForm[formName] = flushFn;
};

export const getFormSaveFlush = formName => flushFunctionsByForm[formName];
